// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EYwk","right":"styles_right__1upE8"};